<template>
  <div>
    <RenewalsFilter
      :prefill="prefillFilters"
      @search="applyFilter"
      @export="handleExport"
      @clear="clearList"
    />

    <ListRenewals :filter="filter" />
  </div>
</template>
<script>
import functions from '../../utils/functions';
import notify from '../../utils/notify';
import renewalsApi from '../../services/renewals.api';
import RenewalsFilter from '../filtros/RenewalsFilter.vue';
import ListRenewals from '../lists/ListRenewals.vue';

export default {
  name: 'RenewalsReport',
  components: {
    RenewalsFilter,
    ListRenewals,
  },
  data() {
    return {
      filter: null,
      prefillFilters: null,
    };
  },
  created() {
    const { endValidityStart, endValidityEnd, brokers } = this.$route.query;
    if (endValidityStart && endValidityEnd) {
      this.prefillFilters = { endValidityStart, endValidityEnd, brokers };
    }
  },
  methods: {
    applyFilter(payload) {
      this.filter = payload;
    },
    clearList() {
      this.filter = null;
    },
    async handleExport(payload) {
      try {
        this.$vs.loading();
        const buffer = await renewalsApi.exportRenewals(payload);
        const now = functions.formataDataMomentJS(
          new Date().toISOString(),
          'DD-MM-YYYY HH:mm',
        );
        await functions.downloadFromBuffer(
          window,
          buffer,
          `Relatório de Renovações - ${now}.xlsx`,
        );
      } catch (error) {
        notify.notifyFail(this.$vs, 'Falha ao exportar o relatório');
      } finally {
        this.$vs.loading.close();
      }
    },
  },
};
</script>
